import * as Yup from "yup";

export const FormLoginScheme = () => {
  return Yup.object().shape({
    email: Yup.string()
      .email("Correo electrónico inválido")
      .required("El correo es obligatorio"),
    password: Yup.string().required("La contraseña es obligatoria"),
  });
};
